import { UserDto } from "app/modules/dashboard/modules/management/user/model/user.dto";
import { DefinitionDto } from "app/modules/shared/model/definition.dto";

export class NumberSchemaDto extends DefinitionDto {
  public document_type: any;
  public user: UserDto;
  public user_role: any;
  public begin_date: Date;
  public end_date: Date;
  public last_num: string;
  public number_scheme_lines: Array<any>;
}
